export default __webpack_public_path__ + "static/dropbox-8f9d0686eed53a95f739accde25ff284.jpg";